import { render, staticRenderFns } from "./PurchaseAssistant.vue?vue&type=template&id=3769c8d6&scoped=true"
import script from "./PurchaseAssistant.vue?vue&type=script&lang=ts"
export * from "./PurchaseAssistant.vue?vue&type=script&lang=ts"
import style0 from "./PurchaseAssistant.vue?vue&type=style&index=0&id=3769c8d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3769c8d6",
  null
  
)

export default component.exports